import { Helper } from '../Helper';
export class MapEveryHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, options) {
        sb.emitSysCall(node, 'Neo.Iterator.Create');
        sb.emitHelper(node, options, sb.helpers.rawIteratorEvery({
            each: this.each,
        }));
    }
}

//# sourceMappingURL=MapEveryHelper.js.map
